import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=5b83c82a&scoped=true&"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePasswordModal.vue?vue&type=style&index=0&id=5b83c82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83c82a",
  null
  
)

export default component.exports